import {call, put, takeLatest} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import {
  INGREDIENT_LIBRARY_LIST_ITEM_REQUEST,
  INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
  INGREDIENT_LIBRARY_PAGE_REQUEST,
  INGREDIENT_LIBRARY_SET_FILTER_ITEM,
  INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_LIBRARY_ITEM_LIST_EXPORT,
  INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE,
  INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM,
  INGREDIENT_LIBRARY_ON_CLICK_ROW,
  INGREDIENT_LIBRARY_ON_CLICK_CANCEL,
  INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING,
  INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM,
  INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE,
  INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE,
  INGREDIENT_LIBRARY_DELETE_ITEM,
  INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_SET_UNCATEGORIZED,
  INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT,
  INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS,
  INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL,
  INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL
} from 'actions/ingredients/library/constants'
import * as apiOutlets from 'api/outlets'
import * as actIngredientLibrary from 'actions/ingredients/library'
import * as apiProfile from 'api/profile'
import {initialize, reset, change} from 'redux-form'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as apiIngredientLibrary from 'api/ingredients/library'
import * as actGetExportedFile from 'actions/get-exported-file'
import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpIngCat from 'mixpanel/ingredient/library'
import {sortBy} from 'lodash'

/****************************************
 * API Request saga
 ****************************************/

function * fillForm (library) {
  yield put(initialize('search', {
    categoryId: library.categoryId,
    typeInventoryId: library.typeInventoryId,
    search: library.search
  }))
}

export function * fillFormDetail (request) {
  const {payload: {formatFormDetail}} = request
  yield put(initialize('library', {
    id: formatFormDetail.id,
    name: formatFormDetail.name,
    unit_id: formatFormDetail.id,
    ingredient_category_id: formatFormDetail.ingredient_category_id,
    in_stock: formatFormDetail.in_stock,
    alert: formatFormDetail.alert,
    stock_alert: formatFormDetail.stock_alert,
    unit_cost: formatFormDetail.unit_cost,
    track_cogs: formatFormDetail.track_cogs,
    cogs: formatFormDetail.cogs,
    time_synchronized: formatFormDetail.time_synchronized,
    is_recipe: formatFormDetail.is_recipe,
    category_name: formatFormDetail.category_name,
    description: formatFormDetail.description,
    business_id: formatFormDetail.business_id,
    outlet_id: formatFormDetail.outlet_id
  }))
}

export function * fillFormLibraryInventory (library) {
  yield put(initialize('libraryInventory', {
    in_stock: library.in_stock,
    alert: library.alert,
    stock_alert: library.stock_alert
  }))
}

export function * fillFormCOGS (library) {
  yield put(initialize('libraryCOGS', {
    track_cogs: library.id ? library.track_cogs : true,
    cogs: library.cogs
  }))
}

export function * fetchSummary (params) {
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiIngredientLibrary.getSummary, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(act.hideProgressBar())
  }
}

function * setFilterLibrary (request) {
  yield put(actIngredientLibrary.setLibraries([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {categoryId, typeInventoryId, keyword, outletIds}} = request
  yield put(actIngredientLibrary.setFilterState(categoryId, typeInventoryId, keyword))
  yield put(act.showProgressBar())
  try {
    yield call(librariesRequest, {page: 1, categoryId, typeInventoryId, keyword})
    mpIngCat.ingredientLibraryChangeFilter({outletIds: outletIds, categoryIds: categoryId, inventoryIds: typeInventoryId})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

function * fillSearch (profile) {
  let assignedOutletIds = []
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {'outletIds': assignedOutletIds}
  yield put(initialize('search', data))
}

export function * onChangeOutletIds (request) {
  yield put(actIngredientLibrary.setLibraries([]))
  yield put(actIngredientLibrary.setLibrarySummary([]))
  yield call(closeRightColumn)
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds, categoryId, typeInventoryId}} = request
  try {
    yield put(act.showProgressBar())
    yield call(apiOutlets.patchLogin, {id: outletIds})
    let resProfile = yield call(apiProfile.getProfile)
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
    yield put(actIngredientLibrary.unSetFilterState())
    yield call(fillForm, {categoryId: 0, typeInventoryId: 0, search: ''})
    yield call(fillSearch, resProfile.data)
    yield put(actIngredientLibrary.listCategoryWithUncategorizedRequest())

    yield call(librariesRequest, {page: 1, categoryId: 0, typeInventoryId: 0, keyword: ''})
    mpIngCat.ingredientLibraryChangeFilter({outletIds: outletIds, categoryIds: categoryId, inventoryIds: typeInventoryId})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

/**
 * Listen for page request of librarylibrary. This just works like wrapper
 */
export function * pageRequestFlow () {
  yield put(act.showProgressBar())
  yield put(showPageLoadingSpinner(true))
  yield put(actIngredientLibrary.setLibraries([]))
  yield put(actIngredientLibrary.setLibrarySummary([]))
  yield put(actIngredientLibrary.setLibraryDetail(null))
  yield put(actIngredientLibrary.setOutlets([]))
  yield put(actIngredientLibrary.setUnits([]))
  yield put(actIngredientLibrary.showColInputInventory(false))
  yield put(actIngredientLibrary.showColInputCOGS(false))
  yield put(reset('library'))
  yield call(closeRightColumn)

  try {
    yield call(fillForm, {categoryId: 0, typeInventoryId: 0, search: ''})
    yield call(librariesRequest, {page: 1, categoryId: 0, typeInventoryId: 0, keyword: ''})
    let response = yield call(apiOutlets.outlets)
    yield put(actIngredientLibrary.setOutlets(response.data))
    let resProfile = yield call(apiProfile.getProfile)
    yield call(fillSearch, resProfile.data)
    yield put(actIngredientLibrary.listCategoryWithUncategorizedRequest())
    mpIngCat.ingredientLibraryStart({outletIds: [resProfile.data.outlet_id[0]], categoryIds: 0, inventoryIds: 0, totalItems: 0})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * getLibraries (params) {
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiIngredientLibrary.getLibraries, params)
    return response
  } catch (error) {
    // If we get an error we send Redux the appropiate action and return
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * librariesRequest (request) {
  let categoryId, typeInventoryId, keyword, page, previousLibraries, libraries
  if (request.payload) {
    let requestPayload = request.payload.query
    let filterState = requestPayload.filterState
    previousLibraries = request.payload.previousLibraries
    categoryId = filterState.categoryId
    typeInventoryId = filterState.typeInventoryId
    keyword = filterState.keyword
    page = requestPayload.page
  } else {
    categoryId = request.categoryId
    typeInventoryId = request.typeInventoryId
    keyword = request.keyword
    page = request.page
  }
  let query = {
    page: page,
    category_id: !parseInt(categoryId) ? '' : categoryId,
    inventory: !parseInt(typeInventoryId) ? 'all' : (typeInventoryId === '1' ? 'low' : 'out'),
    keyword: !keyword ? '' : keyword
  }

  yield put(act.showProgressBar())
  try {
    let response = yield call(getLibraries, query)
    let librariesResponse = response
    if (previousLibraries) {
      libraries = previousLibraries.concat(librariesResponse)
    } else {
      libraries = librariesResponse
    }
    yield put(actIngredientLibrary.setLibraries(libraries)) // todo refactor
    if (page <= 1) {
      let summary = yield call(fetchSummary, query) // todo refactor
      yield put(actIngredientLibrary.setLibrarySummary(summary.meta))
      yield put(actIngredientLibrary.setTotalPage(summary.meta.total_pages))
    }
    yield put(actIngredientLibrary.setCurrentPage(page))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(showPageLoadingSpinner(false))
    yield put(act.hideProgressBar())
  }
}

/**
 * Listen for listen category request
 * It will fetch category data from the server and set the category state with action
 */
export function * getCategoriesWithUncategorizedFlow () {
  let categories = yield call(apiIngredientLibrary.getCategoriesWithUncategorized)
  if (categories) {
    yield put(actIngredientLibrary.setUncategorized(categories.data))
    yield put(actIngredientLibrary.setCategories(categories.data))
  }
}

export function * getExportLibrary (request) {
  let {payload: {prefix, inventoryId, categoryId, keyword}} = request
  yield put(act.showLoadingSpinner(true))
  try {
    let params = {inventory: inventoryId}
    if (categoryId && categoryId !== '0') {
      params.category_id = categoryId
    }
    if (keyword) {
      params.keyword = keyword
    }
    let response = yield call(apiIngredientLibrary.getExportLibrary, params)
    if (response.statusText === 'OK') {
      yield put(actGetExportedFile.getExportedWithoutOutlet(prefix))
    } else {
      yield put(actNotif.error(response.data.message))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.showLoadingSpinner(false))
  }
}

export function * downloadLibrariesTemplate (request) {
  let {payload: {prefix}} = request
  yield put(act.showLoadingSpinner(true))
  try {
    let response = yield call(apiIngredientLibrary.getLibraryTemplate)
    let responseData = response.data
    if (responseData.message === 'ok') {
      yield put(actGetExportedFile.getExportedWithoutOutlet(prefix))
    } else {
      yield put(actNotif.error(responseData.message))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.showLoadingSpinner(false))
  }
}

export function * clickCreateLibrary (request) {
  let {payload: {uncategorized}} = request
  yield put(act.showProgressBar())
  yield put(actIngredientLibrary.setLibraryDetail({}))
  yield call(openRightColumn)
  yield put(actIngredientLibrary.showColInputCOGS(false))
  yield put(actIngredientLibrary.showColInputInventory(false))
  yield put(initialize('library', {
    id: null,
    name: null,
    unit_id: null,
    ingredient_category_id: uncategorized.id,
    in_stock: 0,
    alert: true,
    stock_alert: 0,
    image: {},
    track_cogs: false,
    cogs: null,
    unit_cost: 0,
    time_synchronized: null,
    is_recipe: false,
    category_name: null,
    description: null,
    business_id: null,
    outlet_id: null
  }))
  yield put(reset('libraryInventory'))
  let units = sortBy(yield call(apiIngredientLibrary.getUnits), 'name')
  yield put(actIngredientLibrary.setUnits(units))
  yield put(act.hideProgressBar())
}

function * openRightColumn () {
  yield put(actIngredientLibrary.openRightColumn())
}

function * closeRightColumn () {
  yield put(actIngredientLibrary.closeRightColumn())
}

export function * clickCancel () {
  yield put(reset('library'))
  yield put(actIngredientLibrary.setLibraryDetail(null))
  yield call(closeRightColumn)
}

export function * clickLibraryRow (request) {
  let {payload: {library}} = request
  try {
    yield put(reset('library'))
    yield put(actIngredientLibrary.setLibraryDetail(null))
    yield put(act.showProgressBar())
    yield put(actIngredientLibrary.setLibraryDetail(library))
    let units = sortBy(yield call(apiIngredientLibrary.getUnits), 'name')
    yield put(actIngredientLibrary.setUnits(units))
    let libraryFormat = yield call(formatLibrary, library)
    yield put(initialize('library', {...libraryFormat}))
    yield call(openRightColumn)
    if (library.id) {
      yield put(actIngredientLibrary.showColInputInventory(true))
      if (library.track_cogs) {
        yield put(actIngredientLibrary.showColInputCOGS(true))
      } else {
        yield put(actIngredientLibrary.showColInputCOGS(false))
      }
    }
    mpIngCat.ingredientLibrarySelect({outletIds: library.outlet_id, name: library.name, category: library.category_name, unit: library.unit_name})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * formatLibrary (library) {
  let libraryFormat = {
    id: library.id,
    name: library.name,
    unit_id: library.unit_id,
    ingredient_category_id: library.ingredient_category_id,
    in_stock: library.in_stock,
    alert: library.alert,
    stock_alert: library.stock_alert,
    image: library.image,
    unit_cost: library.unit_cost,
    track_cogs: library.track_cogs,
    cogs: library.cogs,
    unit_name: library.unit_name,
    time_synchronized: library.time_synchronized,
    is_recipe: library.is_recipe,
    category_name: library.category_name,
    description: library.description,
    business_id: library.business_id,
    outlet_id: library.outlet_id
  }
  return libraryFormat
}

export function * onClickBtnLibraryTracking (request) {
  const {payload: {previousLibraryForm}} = request
  yield put(actIngredientLibrary.showLibraryInventoryAleryModal())
  yield put(actIngredientLibrary.setPreviousLibraryForm(previousLibraryForm))
  yield call(fillFormLibraryInventory, {in_stock: previousLibraryForm.in_stock, alert: previousLibraryForm.alert, stock_alert: previousLibraryForm.stock_alert})
}

export function * onCancelLibraryInventoryAlertModal () {
  yield put(actIngredientLibrary.hideLibraryInventoryAleryModal())
  yield put(reset('libraryInventory'))
}

export function * submitFormCreate (request) {
  const {payload: {values, libraries, allOutlet, outletId, summary}} = request
  try {
    let valueLibrary = values.library
    delete valueLibrary.ingredient.id
    yield put(act.showProgressBar())
    yield put(actIngredientLibrary.isSubmittingForm(true))
    let postLibraryRes
    let updatedLibrary
    if (allOutlet) {
      postLibraryRes = yield call(apiIngredientLibrary.postCreateAllOutletLibrary, valueLibrary)

      const createdLibraries = postLibraryRes.data.ingredients
      for (let i = 0; i < createdLibraries.length; i++) {
        if (createdLibraries[i].outlet_id === outletId) {
          updatedLibrary = createdLibraries[i]
          libraries.unshift(createdLibraries[i])
        }
      }

      yield put(actIngredientLibrary.setCreatedOutlets({
        outletsFailed: postLibraryRes.data.outlet_failed,
        outletsSuccess: postLibraryRes.data.outlet_success}))
      yield put(actIngredientLibrary.showSaveToAllOutletsModal())
    } else {
      postLibraryRes = yield call(apiIngredientLibrary.postLibrary, valueLibrary)
      updatedLibrary = postLibraryRes.data
      libraries.unshift(postLibraryRes.data)
    }
    let libraryFormat = yield call(formatLibrary, updatedLibrary)
    yield put(initialize('library', {...libraryFormat}))
    yield put(actIngredientLibrary.setLibraries(libraries))
    yield put(actIngredientLibrary.setLibraryDetail(libraryFormat))
    yield put(actIngredientLibrary.setLibrarySummary({...summary, total_count: summary.total_count + 1}))
    yield put(actNotif.success('Ingredient successfully created.'))
    yield put(actIngredientLibrary.onClickRow(libraryFormat))
    mpIngCat.ingredientLibraryCreate({allOutlet, ingredient: valueLibrary.ingredient})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actIngredientLibrary.isSubmittingForm(false))
    yield put(act.hideProgressBar())
  }
}

export function * submitFormUpdate (request) {
  const {payload: {libraryId, values, libraries}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actIngredientLibrary.isSubmittingForm(true))
    if (values.library.ingredient.image.url) {
      yield call(apiIngredientLibrary.updateImageById, libraryId, {
        ingredient: {
          image: values.library.ingredient.image.url
        }
      })
    }

    yield call(apiIngredientLibrary.putLibraryById, libraryId, values.library)
    const updatedLibraryRes = yield call(apiIngredientLibrary.getLibraryById, libraryId)
    libraries.forEach((library, index) => {
      if (updatedLibraryRes.id === library.id) {
        libraries[index] = {...updatedLibraryRes}
      }
    })
    let libraryFormat = yield call(formatLibrary, updatedLibraryRes)
    yield put(initialize('library', {...libraryFormat}))
    yield put(actIngredientLibrary.setLibraries(libraries))
    yield put(actIngredientLibrary.setLibraryDetail(updatedLibraryRes))
    yield put(actNotif.success('Ingredient was successfully updated.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actIngredientLibrary.isSubmittingForm(false))
    yield put(act.hideProgressBar())
  }
}

export function * onConfirmLibraryInventoryAlertModal (request) {
  const {payload: {libraryInventoryForm}} = request
  yield put(actIngredientLibrary.showColInputInventory(true))
  yield put(actIngredientLibrary.hideLibraryInventoryAleryModal())
  // change values of library form with values of libraryInventory
  yield put(change('library', 'in_stock', libraryInventoryForm.in_stock))
  yield put(change('library', 'alert', libraryInventoryForm.alert))
  yield put(change('library', 'stock_alert', libraryInventoryForm.stock_alert))
}

export function * deleteLibrary (request) {
  const {payload: {library, previousLibraries, summary}} = request
  try {
    yield put(act.showProgressBar())
    // remove libraries
    let deletedIndex = -1
    previousLibraries.forEach((plibrary, index) => {
      if (plibrary.id === library.id) {
        deletedIndex = index
      }
    })
    if (deletedIndex !== -1) {
      previousLibraries.splice(deletedIndex, 1)
    }
    yield call(apiIngredientLibrary.deleteLibraryByIdV1, library.id)
    yield call(closeRightColumn)
    yield put(actIngredientLibrary.setLibraryDetail(null))
    yield put(reset('library'))
    yield put(actIngredientLibrary.hideDeleteModal())
    yield put(actIngredientLibrary.setLibrarySummary({...summary, total_count: summary.total_count - 1}))
    yield put(actNotif.success('Ingredient was successfully removed.'))
    mpIngCat.ingredientLibraryDelete({outletIds: library.outlet_id, name: library.name, category: library.category_name, unit: library.unit_name})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * onClickCreateCategory (request) {
  const {payload: {category, previousCategories, previousCategoryId}} = request
  yield put(actIngredientLibrary.setNewCategory(category))
  yield put(actIngredientLibrary.setPreviousCategories(previousCategories))
  // push new category since we want to 'manipulate' the view using redux,
  // using id == 0 as 'dummy id' for category
  const categories = [...previousCategories]
  categories.push({
    id: 0,
    name: category
  })
  yield put(actIngredientLibrary.setCategories(categories))
  yield put(actIngredientLibrary.setPreviousCategoryId(previousCategoryId))
  // wait to make the event dispatched successfully propagated
  yield call(delay, 50)
  yield put(change('library', 'ingredient_category_id', 0))
  if (category) {
    yield put(actIngredientLibrary.showNewCategoryModal())
  }
}

export function * onClickCancelCreateCategory (request) {
  const {payload: {previousCategories, previousCategoryId}} = request
  yield put(actIngredientLibrary.setCategories(previousCategories))
  yield put(change('library', 'ingredient_category_id', previousCategoryId))
  yield put(actIngredientLibrary.hideNewCategoryModal())
}

export function * onClickConfirmCreateCategory (request) {
  const {payload: {category}} = request
  try {
    yield put(act.showProgressBar())
    const createCategoryRes = yield call(apiIngredientLibrary.createIngredientCategory, {name: category})
    yield put(change('library', 'ingredient_category_id', createCategoryRes.data.id))
    yield put(actIngredientLibrary.listCategoryWithUncategorizedRequest())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actIngredientLibrary.hideNewCategoryModal())
  }
}

export function * setUncategorized (request) {
  const {payload: {categories}} = request
  let uncategorized = categories.find(category => category.name === 'Uncategorized')
  yield put(actIngredientLibrary.storeUncategorized(uncategorized))
}

export function * onSuccessImport () {
  yield put(actIngredientLibrary.hideImportModal())
  yield put(actIngredientLibrary.closeRightColumn())
  yield put(actNotif.success('Ingredient successfully imported'))
  yield put(actIngredientLibrary.pageRequest())
}

export function * onClickBtnTrackCOGS (request) {
  const {payload: {previousLibraryForm}} = request
  yield put(actIngredientLibrary.showTrackingCOGSModal())
  yield put(actIngredientLibrary.setPreviousLibraryForm(previousLibraryForm))
  yield call(fillFormCOGS, previousLibraryForm)
}

export function * onClickCancelCOGS () {
  yield put(actIngredientLibrary.hideTrackingCOGSModal())
  yield put(reset('libraryCOGS'))
}

export function * onConfirmCOGS (request) {
  const {payload: {libraryCOGSForm, previousLibraryForm, showInputCOGS}} = request
  let show = false

  yield put(change('library', 'track_cogs', libraryCOGSForm.track_cogs))
  yield put(change('library', 'cogs', libraryCOGSForm.cogs))

  if (previousLibraryForm.id) {
    if (libraryCOGSForm.track_cogs) {
      show = true
    } else {
      if (libraryCOGSForm.cogs && !previousLibraryForm.track_cogs) {
        yield put(change('library', 'cogs', null))
      }
    }
  } else {
    if (libraryCOGSForm.track_cogs) {
      show = true
    } else {
      if (libraryCOGSForm.cogs && !previousLibraryForm.track_cogs) {
        yield put(change('library', 'cogs', null))
      }
    }
  }
  yield put(actIngredientLibrary.showColInputCOGS(show))
  yield put(actIngredientLibrary.hideTrackingCOGSModal())
  mpIngCat.cogsTrackingIngredient({ingredientList: previousLibraryForm, libraryCOGSForm: libraryCOGSForm, showInputCOGS: showInputCOGS})
}

export default function * librarySaga () {
  yield takeLatest(INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST, getCategoriesWithUncategorizedFlow)
  yield takeLatest(INGREDIENT_LIBRARY_SET_FILTER_ITEM, setFilterLibrary)
  yield takeLatest(INGREDIENT_LIBRARY_PAGE_REQUEST, pageRequestFlow)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS, onChangeOutletIds)
  yield takeLatest(INGREDIENT_LIBRARY_LIST_ITEM_REQUEST, librariesRequest)
  yield takeLatest(INGREDIENT_LIBRARY_ITEM_LIST_EXPORT, getExportLibrary)
  yield takeLatest(INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE, downloadLibrariesTemplate)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM, clickCreateLibrary)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_CANCEL, clickCancel)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_ROW, clickLibraryRow)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING, onClickBtnLibraryTracking)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL, onCancelLibraryInventoryAlertModal)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL, onConfirmLibraryInventoryAlertModal)
  yield takeLatest(INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM, fillFormDetail)
  yield takeLatest(INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE, submitFormCreate)
  yield takeLatest(INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE, submitFormUpdate)
  yield takeLatest(INGREDIENT_LIBRARY_DELETE_ITEM, deleteLibrary)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY, onClickCreateCategory)
  yield takeLatest(INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY, onClickConfirmCreateCategory)
  yield takeLatest(INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY, onClickCancelCreateCategory)
  yield takeLatest(INGREDIENT_LIBRARY_SET_UNCATEGORIZED, setUncategorized)
  yield takeLatest(INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT, onSuccessImport)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS, onClickBtnTrackCOGS)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL, onClickCancelCOGS)
  yield takeLatest(INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL, onConfirmCOGS)
}



// WEBPACK FOOTER //
// ./app/sagas/ingredients/library.js